import Color from '@tiptap/extension-color';
import { getStyleProperty } from '@tiptap/core';
import { colorDictionary } from '@/js/util/color-dictionary';

const rgbToHex = (color) => {
  const hexNumber = color
    .match(/\d+/g)
    .slice(0, 3)
    .map((num) => parseInt(num, 10).toString(16).padStart(2, '0'))
    .join('');

  return `#${hexNumber}`;
};

export const colorHex = (color) => {
  if (color.startsWith('rgb')) {
    return rgbToHex(color);
  }
  return colorDictionary[color.toLowerCase()] || color;
};

export const CanonicalColor = Color.extend({
  addGlobalAttributes() {
    return this.parent().map((group) => ({
      ...group,
      attributes: {
        ...group.attributes,
        color: {
          ...group.attributes.color,
          parseHTML: (element) => {
            const value = (getStyleProperty(element, 'color') ?? element.style.color)?.replace(
              /['"]+/g,
              ''
            );
            return value ? colorHex(value).toLowerCase() : value;
          },
        },
      },
    }));
  },
});
